// DeleteAdmin.tsx
import React from "react";
import { Modal, Button, Title, Group } from "@mantine/core";
import classes from "./delete.module.css";

interface DeleteAdminProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteAdmin: React.FC<DeleteAdminProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose}>
      <Title className={classes.title} order={4}>
        Are you sure you want to delete this item?
      </Title>
      <Group className={classes.buttonPart}>
        <Button onClick={onClose} className={classes.buttonCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.buttonDelete}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteAdmin;
